<ion-grid class="shadow-box ion-no-padding" [class]="state">
  <div class="message">
    <span *ngIf="state === 'success'; else statusIcon" class="message__check" aria-hidden="true">
      <ds-icon name="check" size="18px"></ds-icon>
    </span>
    <ng-template #statusIcon>
      <ion-icon class="message__icon" name="{{ message[state].icon }}"></ion-icon>
    </ng-template>
    <ion-text class="message__text">
      <h3>{{ message[state].title }}</h3>
      <p>{{ message[state].subtitle }}</p>
    </ion-text>
    <ds-icon-button-v2
      class="message__close"
      emphasis="secondary-filled"
      size="s"
      icon="Close"
      ariaLabel="Cerrar mensaje"
      (clicked)="closeMessage()"
    ></ds-icon-button-v2>
  </div>
</ion-grid>
